import _taggedTemplateLiteral from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from "styled-components";
import { size } from "./../../../shared/constants";
import { Row } from "./../../Grid";
var HeaderRow = styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n"])), size.lg);
export { HeaderRow };